import {utilHelper} from "../../_helpers";

const relativeUrl = '/api/requestMap'

export const requestMapService = {
    getList,
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    getPagedList,
};

function getPagedList(offset, max) {
    return utilHelper.doRequest(`${relativeUrl}?max=${max}&offset=${offset}`, 'GET')
}


function getList() {
    return utilHelper.doRequest(`${relativeUrl}`, 'GET')
}

function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

function saveItem(data) {
    return utilHelper.doRequest(`${relativeUrl}`, 'POST', data);
}

function updateItem(id, data) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'PUT', data);
}

function deleteItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'DELETE')
}